import { render, staticRenderFns } from "./ModalReportSGF.vue?vue&type=template&id=d7dddff2"
import script from "./ModalReportSGF.vue?vue&type=script&lang=js"
export * from "./ModalReportSGF.vue?vue&type=script&lang=js"
import style0 from "./ModalReportSGF.vue?vue&type=style&index=0&id=d7dddff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports